import { format } from "date-fns";

export const toDateInputValue = (date) =>
  date ? format(date, "yyyy-MM-dd") : "";

export const fromDateInputValue = (value) => {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const toggleFilterListValue = (list, value) =>
  list.includes(value)
    ? list.filter((item) => item !== value)
    : [...list, value];

export const parseAmountInput = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const normalized = String(value).replace(/\./g, "").replace(",", ".");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatFilterDate = (date) =>
  date ? format(date, "dd/MM/yyyy") : "";

export const formatFilterAmount = (value) => {
  const parsed = parseAmountInput(value);
  if (parsed === null) return "";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(parsed);
};

export const labelById = (options, id) =>
  options.find((option) => option.id === id)?.label || id;

export const startOfDay = (date) => {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
};

export const endOfDay = (date) => {
  const next = new Date(date);
  next.setHours(23, 59, 59, 999);
  return next;
};

/**
 * Statement API `start_date`: local start of day → UTC ISO.
 * BaaS stores CreatedAt in UTC; date-only midnight would truncate the BR evening window.
 */
export const formatStatementApiStartDate = (date) => {
  if (!date) return "";
  return startOfDay(date).toISOString();
};

/**
 * Statement API `end_date`: local end of day (23:59:59.999) → UTC ISO.
 * BaaS treats timed end_date as inclusive upper bound (see StatementDateBounds).
 */
export const formatStatementApiEndDate = (date) => {
  if (!date) return "";
  return endOfDay(date).toISOString();
};

/** Parse statement `start_date` / `end_date` back to a local calendar Date for pickers. */
export const parseStatementApiFilterDate = (value) => {
  if (!value) return null;
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month, day] = raw.split("-").map(Number);
    return new Date(year, month - 1, day);
  }
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return null;
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
};

export const downloadCsv = (headers, rows, fileName) => {
  const csvContent = [headers, ...rows]
    .map((row) =>
      row
        .map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`)
        .join(";"),
    )
    .join("\n");

  const blob = new Blob([`\uFEFF${csvContent}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
